import { useTranslate } from "@tolgee/react";
import { Button } from "#/components/ui/button";
import {
	useDeposit,
	useExternalWithdraw,
	useTransferToWallet,
} from "#/hooks/use-trading-actions";
import { DepositDialog } from "../order-form/deposit-dialog";
import { DepositWarningIndicator } from "../order-form/deposit-warning-indicator";
import { WithdrawDialog } from "../order-form/withdraw-dialog";
import { WithdrawStatusIndicator } from "../order-form/withdraw-status-indicator";

export function AccountInfoActions() {
	const { t } = useTranslate();
	const deposit = useDeposit();
	const transferToWallet = useTransferToWallet();
	const withdraw = useExternalWithdraw();

	return (
		<div className={"flex gap-2"}>
			<DepositDialog onConfirm={(amount) => deposit.mutateAsync(amount)}>
				<Button
					disabled={deposit.isPending}
					className="flex-1 px-4 py-2.5 text-trade-text-strong text-primary-foreground"
				>
					{deposit.isPending ? t("actions.depositing") : t("actions.deposit")}
					{!deposit.isPending && (
						<DepositWarningIndicator
							className="ml-0.5"
							statusClassName="text-primary-foreground"
						/>
					)}
				</Button>
			</DepositDialog>

			<WithdrawDialog
				onTransferToWallet={async (amount) => {
					await transferToWallet.mutateAsync(amount);
				}}
				onExternalWithdraw={async ({ amount, destination }) => {
					await withdraw.mutateAsync({ amount, destination });
				}}
			>
				<Button
					variant={"outline"}
					disabled={transferToWallet.isPending || withdraw.isPending}
					className="flex-1 px-4 py-2.5 text-trade-text-strong"
				>
					{withdraw.isPending
						? t("actions.withdrawing")
						: t("actions.withdraw")}
					<WithdrawStatusIndicator className="ml-0.5" />
				</Button>
			</WithdrawDialog>
		</div>
	);
}
